import React, { useEffect, useState } from "react";
import axios from "axios";

const EVENT_ID = "6ab75fdf6c81049468e7b79b";
const TICKETS_URL = `https://api.sortyfy.com/api/eventcart/getAllTicketForAdmin?eventId=${EVENT_ID}`;

const getTickets = (response) => {
  const candidates = [response?.data, response?.data?.data, response?.data?.tickets];
  return candidates.find(Array.isArray) || [];
};

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

const labelFor = (key) =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/[_-]/g, " ")
    .replace(/^\w/, (letter) => letter.toUpperCase());

const TicketList = () => {
  const [state, setState] = useState({ loading: true, tickets: [], error: "" });

  useEffect(() => {
    let active = true;
    axios
      .get(TICKETS_URL)
      .then((response) => {
        if (active) setState({ loading: false, tickets: getTickets(response), error: "" });
      })
      .catch((error) => {
        if (active) {
          setState({
            loading: false,
            tickets: [],
            error: error?.response?.data?.message || "Could not load tickets. Please try again.",
          });
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <main style={{ minHeight: "100vh", padding: "32px 20px", background: "#f1f5f9", fontFamily: "Arial, sans-serif" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <header style={{ marginBottom: 24 }}>
          <h1 style={{ margin: "0 0 8px", color: "#0f172a", fontSize: 28 }}>Event tickets</h1>
          <p style={{ margin: 0, color: "#64748b" }}>Ticket list for event {EVENT_ID}</p>
        </header>

        {state.loading ? (
          <p role="status" style={{ color: "#475569" }}>Loading tickets…</p>
        ) : state.error ? (
          <p role="alert" style={{ color: "#b91c1c" }}>{state.error}</p>
        ) : state.tickets.length === 0 ? (
          <p style={{ padding: 24, background: "#fff", borderRadius: 10, color: "#475569" }}>No tickets found for this event.</p>
        ) : (
          <>
            <p style={{ color: "#475569" }}>{state.tickets.length} ticket{state.tickets.length === 1 ? "" : "s"}</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 }}>
              {state.tickets.map((ticket, index) => {
                const fields = ticket && typeof ticket === "object" ? Object.entries(ticket) : [["ticket", ticket]];
                return (
                  <article key={ticket?._id || ticket?.ticketId || index} style={{ padding: 20, background: "#fff", borderRadius: 10, boxShadow: "0 2px 8px rgba(15, 23, 42, 0.06)" }}>
                    <h2 style={{ margin: "0 0 14px", color: "#0f172a", fontSize: 18 }}>Ticket {index + 1}</h2>
                    <dl style={{ display: "grid", gridTemplateColumns: "minmax(90px, auto) 1fr", gap: "8px 12px", margin: 0, overflowWrap: "anywhere" }}>
                      {fields.map(([key, value]) => (
                        <React.Fragment key={key}>
                          <dt style={{ color: "#64748b", fontSize: 13 }}>{labelFor(key)}</dt>
                          <dd style={{ margin: 0, color: "#1e293b", fontSize: 14 }}>{formatValue(value)}</dd>
                        </React.Fragment>
                      ))}
                    </dl>
                  </article>
                );
              })}
            </div>
          </>
        )}
      </div>
    </main>
  );
};

export default TicketList;
